$(document).ready(function() {
  // add required classes starts
  var $items_fadein = $(".enable-fadein .items_list_item");
  $items_fadein.each(function(index, item) {
    $(item).addClass('fade-in-section');
  });

  if (window.innerWidth  <= 670) {
    var $items_show_more = $(".enable-show-more");
    $items_show_more.each(function(index, item) {
      var visible_items = $(item).data('show-more-tiles') || 5;
      var see_all_items_text = 'See All Items';
      if ($(item).data('see-all-items-text')) {
        see_all_items_text = 'See All ' + $(item).data('see-all-items-text') + ' Items'
      }
      var $items_list_item = $(item).find('.items_list_item');
      $items_list_item.each(function(index, list_item){
        if ($items_list_item.length > visible_items) {
          if (index == visible_items - 1) {
            $('.items_list.enable-fadein.enable-show-more').css('padding-bottom','50px');
            $(list_item).addClass('gradiant-fade');
            $(list_item).after("<a href='javascript:void(0);' class='box-items-see-all'><span>" + see_all_items_text + "</span</a>");
          }

          if (index > visible_items - 1) {
            $(list_item).addClass('item-display-none');
          }
        }
      });
      
    });
  }
  
  // add required classes ends
  
  $('body').on('click', '.box-items-see-all', function(e){
    var show_more_container = $(e.target).closest('.enable-show-more');
    var hidden_list_items = $(show_more_container).find('.items_list_item.item-display-none');
    $(show_more_container).find('.items_list_item').removeClass('item-display-none');
    $(show_more_container).find('.items_list_item.gradiant-fade').removeClass("gradiant-fade");
    $(e.target).remove();
  });


  // Fade-In JS starts
  var options = {
    root: null,
    threshold: 0,
    rootMargin: "-150px"
  };

  var sections = $('.fade-in-section');

  var observer = new IntersectionObserver(function(entries, observer){
    entries.forEach(function(entry){
      if (!entry.isIntersecting) {
        return;
      }

      $(entry.target).addClass('is-visible');
      $(entry.target).find('.item_card_slider').slick("unslick");
      $(entry.target).find('.item_card_slider').slick({adaptiveHeight: true, dots: true});
      observer.unobserve(entry.target);
    });
  });

  sections.each(function(index, section){
    observer.observe(section);
  });
  
  // Fade-In JS starts
});
